<script>
import countlyVue from '../../compat/vue-core';

const popoverSizes = {
  small: true,
  medium: true,
  auto: true,
  'small-chart': true,
  'medium-chart': true,
  'auto-chart': true,
};

export default countlyVue.components.BaseComponent.extend({
  props: {
    size: {
      type: String,
      default: 'medium',
      validator(val) {
        return val in popoverSizes;
      },
    },
  },
  computed: {
    contentClasses() {
      return `cly-vue-popover__content cly-vue-popover__content--${this.size}`;
    },
  },
});
</script>
<template>
  <v-popover
    :popover-inner-class="contentClasses"
    class="cly-vue-popover"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
    <template #popover>
      <slot name="content" />
    </template>
  </v-popover>
</template>
